export default {
    header: "Você foi deslogado com sucesso",
    message: ""
}